import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import {
  StyledBottomContainer,
  StyledButtonDownload,
  StyledCardNews,
  StyledCarousel,
  StyledContainer,
  StyledCtaButton,
  StyledDocuments,
  StyledHeading,
  StyledInformation,
  StyledMedia,
  StyledRichText,
  StyledSeparator,
  StyledTopContainer,
  StyledWhiteBlock,
} from './PageWithBannerPresentation.styled'

import ButtonVariantEnum from '../../enums/ButtonVariant'
import { CarouselVariantEnum } from '../Carousel/Carousel'
import ContentType from '../../enums/ContentType'
import { getSizeFromDocument } from '../../utils/GetSizeFromDocument'
import HeadingSizeEnum from '../../enums/headingSize'
import UrlFactory from '../../utils/UrlFactory'

const READ_MORE = 'Read More'

const pageTypeMatcher = {
  ContentfulTemplateArticle: ContentType.templateArticle,
  ContentfulTemplatePageStory: ContentType.templatePageStory,
}

const PageWithBannerPresentation = (props) => {
  const { cards, className, cta, documents, media, text, title } = props

  const documentsList = useMemo(
    () =>
      documents?.map((doc, index) => (
        <StyledButtonDownload
          key={index}
          name={doc.name}
          description={getSizeFromDocument(doc)}
          document={doc}
        />
      )),
    [documents]
  )

  const cardsList = useMemo(
    () =>
      cards?.map((card, index) => {
        const description =
          card?.metaDescription?.seoMetaDescription || card.seoMetaDescription

        const slug = UrlFactory.getRightUrlForSearch(
          pageTypeMatcher[card.__typename],
          card.slug
        )

        return (
          <StyledCardNews
            backgroundColor={card.backgroundColor}
            ctaCardLabel={READ_MORE}
            description={description}
            isOtherPage
            key={card.title + index}
            slug={slug}
            thumbnail={card.thumbnail}
            title={card.title}
          />
        )
      }),
    [cards]
  )

  return (
    <StyledContainer className={className}>
      <StyledWhiteBlock>
        <StyledInformation>
          <StyledTopContainer>
            {title && <StyledHeading label={title} size={HeadingSizeEnum.h2} />}
            {text && <StyledRichText html={text.content} />}
          </StyledTopContainer>
          <StyledBottomContainer>
            {documentsList?.length && (
              <StyledDocuments>{documentsList}</StyledDocuments>
            )}
            {cta ? (
              <StyledCtaButton
                label={cta.label}
                to={cta.url}
                variant={ButtonVariantEnum.primary}
              />
            ) : null}
          </StyledBottomContainer>
        </StyledInformation>
        {media && !cardsList?.length ? (
          <>
            <StyledSeparator></StyledSeparator>
            <StyledMedia media={media} />
          </>
        ) : null}
      </StyledWhiteBlock>
      {cardsList?.length ? (
        <StyledCarousel variant={CarouselVariantEnum.media}>
          {cardsList}
        </StyledCarousel>
      ) : null}
    </StyledContainer>
  )
}

PageWithBannerPresentation.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
  cta: PropTypes.object,
  documents: PropTypes.array,
  media: PropTypes.object,
  text: PropTypes.object,
  title: PropTypes.string,
}

export default PageWithBannerPresentation
